module.exports = __webpack_public_path__ + "img/AUTO_TRANSPORTS_DESACTIVE.0077af5a.svg";